<section id="price">
    <div class="container price-container" id="price_section" *ngIf="priceModel || premiumDiscountModel">
        <div class="row price-heading-container">
            <div class="col-sm-12">
                <h2 class="price-heading rps-heading-two" id="price_header">Price</h2>
            </div>
        </div>

        <app-current-price [priceModel]="priceModel" (callRefreshFunc)="callRefresh(false);"></app-current-price>
        <div>
            <app-closing-price *ngIf="!(priceModel?.profile?.isExternalFund && priceModel?.profile?.isETF)" [fundAnalyticsModel]="fundAnalyticsModel" [priceModel]="priceModel"></app-closing-price>
            <app-historical-price *ngIf="!(is529Fund && isMoneyMarketFund)" [priceModel]="priceModel" [shareSplitDate]="priceModel?.shareSplitDate" [shareSplitPrice]="priceModel?.shareSplitPrice" [historicalPriceModel]="allPrice"></app-historical-price>
        </div>
        <c11n-accordion-group *ngIf="priceModel && priceModel?.profile && priceModel?.profile?.isETF && !(priceModel?.profile?.isExternalFund && priceModel?.profile?.isETF)"
            class="row mt-4" (stateChange)="stateChangeHandler($event)">
            <c11n-accordion
                class="d-block"
                [headingLevel]="4"
                [labelText]="'Premium/Discount chart'"
                [size]="isLargeScreen ? 'medium': 'large'"
                [labelWeight]="'bold'">
                    <div accordion-body>
                        <app-premium-discount [premiumDiscountModel]="premiumDiscountModel"
                            [ticker]="priceModel?.profile?.ticker"
                            [fundId]="priceModel.profile.fundId"
                            [shareSplitDate]="priceModel?.shareSplitDate"
                            [shareSplitPrice]="priceModel?.shareSplitPrice"></app-premium-discount>
                    </div>
            </c11n-accordion>
        </c11n-accordion-group>
    </div>
</section>
